import 'babel-polyfill';
import 'font-awesome-sass-loader';
import 'jquery-ui-bundle';
import './css/theme.css';
import './css/style.scss';

import angular from 'angular';
import AngularUiRouter from 'angular-ui-router';
import AngularAnimate from 'angular-animate';
import AngularSanitize from 'angular-sanitize';
import AngularBootstrap from 'angular-ui-bootstrap';
import ngRedux from 'ng-redux';
import { persistStore, autoRehydrate, getStoredState } from 'redux-persist';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';


/*eslint-disable */
import LocalStorageModule from 'angular-local-storage';
/*eslint-enable */

import AppCore from 'core';
import { AppComponent } from './app.component';
import { rest } from 'core/api';
import spaI18N from 'core/i18n';
import TokenService from 'core/services/token-service';
import CurrentUserService from 'core/services/current-user-service';

import Home from './components/home';
import Landing from './components/landing';
import TableroTrabajo from './components/tablero-trabajo';
import TableroEspecialista from './components/tablero-especialistas';
import TableroComisiones from './components/tablero-comisiones';
import TableroCliente from './components/tablero-clientes';
import TableroTurno from './components/tablero-turnos';
import Login from './components/login';
import Usuarios from './components/usuarios';
import Sucursales from './components/sucursales';
import PuntosEmision from './components/puntos-emision';
import Parametros from './components/parametros';
import Navigation from './components/navigation';
import Topbar from './components/topbar';
import Roles from './components/roles';
import Timbrados from './components/timbrados';
import TiposImpuestos from './components/tipos-impuestos';
import CategoriasProductos from './components/categorias-productos';
import Marcas from './components/marcas';
import TiposAtributoCliente from './components/tipos-atributo-cliente';
import AtributosCliente from './components/atributos-cliente';
import UnidadesMedidas from './components/unidades-medidas';
import FamiliasProductos from './components/familias-productos';
import TiposComprobantes from './components/tipos-comprobantes';
import Proveedores from './components/proveedores';
import Adicionales from './components/adicionales';
import Cotizaciones from './components/cotizaciones';
import PeriodosNominas from './components/periodos-nominas';
import FranjasHorarias from './components/franjas-horarias';
import TurnosTrabajos from './components/turnos-trabajos';
import Productos from './components/productos';
import TiposMarcaciones from './components/tipos-marcaciones';
import TiposMovimientosNominas from './components/tipos-movimientos-nominas';
import TiposMovimientosFondosFijos from './components/tipos-movimientos-fondos-fijos';
import TransaccionesFondosFijos from './components/transacciones-fondos-fijos';
import MovimientosNominas from './components/movimientos-nominas';
import TiposMovimientosFraccionados from './components/tipos-movimientos-fraccionados';
import MovimientosFraccionados from './components/movimientos-fraccionados';
import Asistencias from './components/asistencias';
import ResumenComisiones from './components/comisiones-empleado';
import Salarios from './components/salarios';
import Feriados from './components/feriados';
import Empleados from './components/empleados';
import Clientes from './components/clientes';
import Precios from './components/precios';
import Paquetes from './components/paquetes';
import Giftcards from './components/giftcards';
import Cajas from './components/cajas';
import Ruc from './components/ruc';
import ProcesadorasTarjetas from './components/procesadoras-tarjetas';
import FormasPago from './components/formas-pago';
import EmisoresTarjetas from './components/emisores-tarjetas';
import MarcasTarjetas from './components/marcas-tarjetas';
import ProcesosBatch from './components/procesos-batch';
import Citas from './components/citas';
import Turnos from './components/turnos';
import Ordenes from './components/ordenes';
import Facturas from './components/facturas';
import Cuotas from './components/cuotas';
import NotasCredito from './components/notas-credito';
import Especialidades from './components/especialidades';
import PlanillasSalarios from './components/planillas-salarios';
import Comisiones from './components/comisiones';
import Disponibilidades from './components/disponibilidades';
import Marcaciones from './components/marcaciones';
import SolicitudesPermisos from './components/solicitudes-permisos';
import Notifications from './components/notifications';
import Estadisticas from './components/estadisticas';
import Reportes from './components/reportes';

import configFile from 'config.json';
import breadcrumbTemplate from 'components/breadcrumb/breadcrumb.html';
import onScreenKeyboardTemplate from 'components/util/angular-on-screen-keyboard.html.string';
import uiSelectTemplate from 'components/util/ui-select.html.string';
import datePickerTemplate from 'components/util/validated-date-input.html.string';
import hourPickerTemplate from 'components/util/hour-picker.html.string';


import {
  loginReducer,
  formReducer,
  navigationReducer,
  rolesReducer,
  excepcionFormReducer,
  notificationDropdownReducer
} from './core/services';

const appName = 'spa';
let initialState = {};

export default angular.module(appName, [
  // framework wide components
  AngularUiRouter,
  ngRedux,
  AngularAnimate,
  AngularSanitize,
  AngularBootstrap,
  'ui.tree',

  // incluimos ui
  'ui',
  'ui.auth',
  'ngNotify',
  'ngCsv',
  'angularScreenfull',

  // services
  'LocalStorageModule',
  AppCore,
  spaI18N,

  // componentes del proyecto
  Home,
  Landing,
  TableroTrabajo,
  TableroEspecialista,
  TableroComisiones,
  TableroCliente,
  TableroTurno,
  Login,
  Marcas,
  TiposAtributoCliente,
  AtributosCliente,
  Usuarios,
  Sucursales,
  PuntosEmision,
  Parametros,
  Navigation,
  Topbar,
  Roles,
  Timbrados,
  TiposImpuestos,
  CategoriasProductos,
  UnidadesMedidas,
  FamiliasProductos,
  TiposComprobantes,
  Proveedores,
  Adicionales,
  Cotizaciones,
  PeriodosNominas,
  FranjasHorarias,
  TurnosTrabajos,
  Productos,
  TiposMarcaciones,
  TiposMovimientosNominas,
  TiposMovimientosFondosFijos,
  TransaccionesFondosFijos,
  MovimientosNominas,
  TiposMovimientosFraccionados,
  MovimientosFraccionados,
  Asistencias,
  ResumenComisiones,
  Salarios,
  Feriados,
  Empleados,
  Clientes,
  Precios,
  Paquetes,
  Giftcards,
  Cajas,
  Ruc,
  ProcesadorasTarjetas,
  FormasPago,
  EmisoresTarjetas,
  MarcasTarjetas,
  ProcesosBatch,
  Citas,
  Turnos,
  Ordenes,
  Facturas,
  Cuotas,
  NotasCredito,
  Especialidades,
  PlanillasSalarios,
  Comisiones,
  Disponibilidades,
  Marcaciones,
  SolicitudesPermisos,
  Notifications,
  Estadisticas,
  Reportes,
  'angular-virtual-keyboard',
  'ui.tree',
  'xeditable',
  'hl.sticky'
])
  .config(config)
  .run(run)
  .factory('TokenService', TokenService)
  .factory('CurrentUserService', CurrentUserService)
  .component(AppComponent.selector, AppComponent)
  .name;


config.$inject = [
  '$stateProvider', '$urlRouterProvider', 'localStorageServiceProvider', 'AuthConfigProvider',
  '$ngReduxProvider', '$httpProvider', 'flowFactoryProvider', '$breadcrumbProvider', 'VKI_CONFIG'
];

function config($stateProvider, $urlRouterProvider, localStorageServiceProvider,
  AuthConfigProvider, $ngReduxProvider, $httpProvider, flowFactoryProvider,
  $breadcrumbProvider, VKI_CONFIG) {
  flowFactoryProvider.defaults = {
    singleFile: false,
    method: 'octet',
    target: configFile.serverURL + '/adjuntos'
  };
  $httpProvider.interceptors.push('HttpInterceptor');
  localStorageServiceProvider.setPrefix(appName);
  $urlRouterProvider.otherwise(function($injector, $location) {
    var $state = $injector.get('$state');
    if ($location.hash() === '' && $location.path() === '') {
      $state.go('home.landing');
    } else {
      $state.go('404');
    }
  });

  AuthConfigProvider.config({
    preffix: 'spa',
    serverURL: configFile.serverURL,
    loginPath: configFile.loginPath,
    tokenPath: '/jwt/token',
    logout: () => {
      console.log("LOGOUT");
    }
  });

  $breadcrumbProvider.setOptions({
    templateUrl: breadcrumbTemplate
  });
  const middleware = ['apiMiddleware', thunk];

  const reducers = Object.assign({
    login: loginReducer,
    form: formReducer,
    navigation: navigationReducer,
    rolesForm: rolesReducer,
    excepcionForm: excepcionFormReducer,
    notificationDropdown: notificationDropdownReducer
  }, rest.reducers);
  let reducer = combineReducers(reducers);
  $ngReduxProvider.createStoreWith(reducer, middleware, [autoRehydrate()], initialState);

  VKI_CONFIG.layout.Numerico = {
    'name': 'Numerico',
    'keys': [
    [['   1   ', '1'], ['   2   ', '2'], ['   3   ', '3']],
    [['   4   ', '4'], ['   5   ', '5'], ['   6   ', '6']],
    [['   7   ', '7'], ['   8   ', '8'], ['   9   ', '9']],
    [['      ', 'Bksp'], ['   0   ', '0'], ['     ', 'Enter']]],
    'lang': ['']
  };

  /* CHANGE TEXT LANGUAGE */
  VKI_CONFIG.i18n = {
    '00': 'Mostrar teclado numérico',
    '01': 'Mostrar teclado virtual',
    '02': 'Selecionar layout del, teclado',
    '03': 'Teclas muertas',
    '04': 'Fijo',
    '05': 'Desligado',
    '06': 'Cerrar teclado',
    '07': '',
    '08': 'Limpiar campo',
    '09': 'Versión',
    '10': 'Diminuir tamaño del teclado',
    '11': 'Aumentar tamaño del teclado'
  };
  VKI_CONFIG.relative = false;
  VKI_CONFIG.sizeAdj = false;
}

run.$inject = ['$transitions', '$ngRedux', '$state', '$templateCache', 'editableOptions', 'editableThemes'];

function run($transitions, $ngRedux, $state, $templateCache, editableOptions, editableThemes) {
  persistStore($ngRedux);

  let restrictedRouteCriteria = {
    to: (state) => state.access && state.access.requiresLogin
  };

  $transitions.onBefore(restrictedRouteCriteria, () => {
    let state = $ngRedux.getState();

    if (!state.login.accessToken) {
      return $state.target('login', { location: 'replace' });
    }
  });

  $templateCache.put(
    '/templates/angular-on-screen-keyboard.html', onScreenKeyboardTemplate);

  $templateCache.put(
    'views/validated-time-input.html', hourPickerTemplate);

  $templateCache.put(
    'views/validated-uiselect-input.html', uiSelectTemplate);

  $templateCache.put(
    'views/validated-date-input.html', datePickerTemplate);

  editableOptions.theme = 'bs3';
  editableThemes.bs3.inputClass = 'input-xeditable';
  editableThemes.bs3.buttonsClass = 'btn-xeditable';


}

angular.element(document).ready(() => {
  ui.bs.configure(configFile);
  getStoredState({}, (err, state) => {
    initialState = state;
    angular.bootstrap(document, [appName], { strictDi: configFile.strictDi });
  });
});


angular.module(appName).filter('split', function() {
  return function(input, splitChar, splitIndex) {
    if (!input) {
      return '-';
    }
    return input.split(splitChar)[splitIndex];
  };
});

angular.module(appName).service('HeadersUtil', function() {
  this.getHeaderFilename = function(headers) {
    var header = headers('Content-Disposition');
    if (header) {
      var result = header.split(';')[1].trim().split('=')[1];
      return result.replace(/"/g, '');
    }
  };
  this.getHeaderContentType = function(headers) {
    var header = headers('Content-Type');
    return header;
  };
});


angular.module(appName).directive('datepickerLocaldate', ['$parse', function($parse) {
  var directive = {
    restrict: 'A',
    require: ['ngModel'],
    link: link
  };
  return directive;

  function link(scope, element, attr, ctrls) {
    var ngModelController = ctrls[0];

    // called with a JavaScript Date object when picked from the datepicker
    ngModelController.$parsers.push(function(viewValue) {
      console.log(moment(viewValue).format('DD/MM/YYYY'));
      // undo the timezone adjustment we did during the formatting
      //viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
      // we just want a local date in ISO format
      console.log(viewValue.toISOString().substring(0, 10));
      return moment(viewValue).format('DD/MM/YYYY');
    });

    // called with a 'yyyy-mm-dd' string to format
    ngModelController.$formatters.push(function(modelValue) {
      if (!modelValue) {
        return undefined;
      }

      moment(modelValue).format('DD/MM/YYYY');
      // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
      var dt = new Date(modelValue);
      // 'undo' the timezone offset again (so we end up on the original date again)
      //dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
      console.log(dt);
      return dt;
    });
  }
}]);


// WEBPACK FOOTER //
// ./src/app.js